import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { Badge } from 'react-bootstrap';
import { green } from '~theme';

import { FLOATING_BUTTON_HEIGHT } from '~utils/common.utils';

const renderIcon = (icon, faIcon) => {
  if (icon) return <FloatIcon src={icon} />;
  if (faIcon) return <FloatFaIcon className={`fa ${faIcon}`} />;
  return null;
};

const FloatingButton = props => {
  const { portalId, overrideFloater, collapsed } = props;
  const isMobileFullscreen = useSelector(
    state => state.reducer.isMobileFullscreen
  );

  // If we're on a fullscreen view, don't render
  if (isMobileFullscreen) return null;

  // Render all buttons to a container within the App component for easier
  // management
  const container = document.getElementById(portalId || 'floating-button');
  if (container) {
    return ReactDOM.createPortal(
      overrideFloater || <Floater {...props} />,
      container
    );
  }
  return null;
};

const Floater = ({ title, icon, faIcon, onClick, badgeCount, collapsed }) => {
  return (
    <FloaterContainer
      onClick={onClick}
      collapsed={false}
      className={collapsed ? 'collapsed' : ''}
    >
      {renderIcon(icon, faIcon)}
      <FloatTitle>
        <FloatInnerWrapper>{title}</FloatInnerWrapper>
        {!!badgeCount && (
          <Badge variant="light" style={{ color: green }}>
            {badgeCount}
          </Badge>
        )}
      </FloatTitle>
    </FloaterContainer>
  );
};

const FloaterContainer = styled.div`
  width: ${FLOATING_BUTTON_HEIGHT}px;
  height: ${FLOATING_BUTTON_HEIGHT}px;
  background-color: ${green};
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  cursor: pointer;
  z-index: 2;

  transition: all 0.2s ease-in-out;
`;

const FloatIcon = styled.img`
  width: 28px;
  margin-right: 4px;
`;

const FloatFaIcon = styled.i`
  color: white;
  font-size: 28px;
`;

const FloatTitle = styled.div`
  color: white;
  font-size: 14px;
  margin-top: 2px;

  align-self: center;
  text-align: center;
`;

const FloatInnerWrapper = styled.div``;

export default FloatingButton;
